<app-modals></app-modals>
<app-navbar *ngIf="showNavbar"></app-navbar>
<main class="sm:pt-[55px]" [ngClass]="{'!pt-[5px]' : mapOnly}">
    <router-outlet></router-outlet>
</main>
<app-footer *ngIf="showFooter"></app-footer>
<app-cookiebar 
    *ngIf="!cookieAccepted && !mapOnly && !isPrivacyPage"
    (accept)="acceptCookie()"
></app-cookiebar>